import { Typography } from 'antd';
import styled from 'styled-components';
import { CONFIG } from '../constants';

const { Paragraph } = Typography;

const CustomCopyable = styled(Paragraph)`
  > div {
    color: ${() => `${CONFIG.COLOR_PRIMARY}`} !important;
  }
`;
export default CustomCopyable;
